import cx from 'classnames';
import {DateTime} from 'luxon';
import {FC} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {StartEndControllerTab} from './types';

interface TabsProps {
  start: DateTime | null;
  end: DateTime | null;
  selectedTab: StartEndControllerTab;
  onTabClick: (tab: StartEndControllerTab) => void;
  onClearEnd: () => void;
  startError?: boolean;
  endError?: boolean;
  qaIdPrefix?: string;
}

export const Tabs: FC<TabsProps> = ({
  start,
  end,
  selectedTab,
  onTabClick,
  onClearEnd,
  startError,
  endError,
  qaIdPrefix = 'event',
}) => (
  <div className="start-end-controller__tabs">
    <Button
      variant="unstyled-button"
      className={cx('start-end-controller__tab', {
        selected: selectedTab === 'start',
        error: startError,
      })}
      onClick={() => onTabClick('start')}
      data-qa-id={`${qaIdPrefix}-start-tab`}
      aria-label="Event start date"
    >
      <Typography variant="label2" color="charcoal">
        Start
      </Typography>
      {start ? (
        <div>
          <Typography variant="paragraph2">{start.toFormat('EEE MMM dd')}</Typography>
          <Typography variant="paragraph2">{start.toFormat('h:mm a')}</Typography>
        </div>
      ) : (
        <Typography variant="paragraph2" color="pebble">
          Pick a date & time
        </Typography>
      )}
    </Button>
    <Button
      variant="unstyled-button"
      className={cx('start-end-controller__tab', {
        selected: selectedTab === 'end',
        error: endError,
      })}
      onClick={() => onTabClick('end')}
      data-qa-id={`${qaIdPrefix}-end-tab`}
      aria-label="Event end date"
      disabled={!start}
    >
      <Typography variant="label2" color="charcoal">
        End
      </Typography>
      {end ? (
        <div>
          <Typography variant="paragraph2">{end.toFormat('EEE MMM dd')}</Typography>
          <Typography variant="paragraph2">{end.toFormat('h:mm a')}</Typography>
        </div>
      ) : (
        <Typography variant="paragraph2" color="pebble">
          Optional
        </Typography>
      )}
    </Button>
    {end && (
      <Button
        variant="unstyled-button"
        className={cx('start-end-controller__clear-end', {error: endError})}
        onClick={onClearEnd}
        data-qa-id={`${qaIdPrefix}-clear-end`}
        aria-label="Remove event end date"
      >
        <CloseLineIcon ratio={0.625} />
      </Button>
    )}
  </div>
);
